module.exports = __webpack_public_path__ + "static/RocketReels-8dec22314dc594cc738267a2984b3ef9.png";